var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNumber(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 3.25C13.4142 3.25 13.75 3.58579 13.75 4V20C13.75 20.3285 13.5362 20.6188 13.2225 20.7162C12.9087 20.8137 12.5681 20.6956 12.382 20.4249L2.75 6.41484V20C2.75 20.4142 2.41421 20.75 2 20.75C1.58579 20.75 1.25 20.4142 1.25 20V4.00009C1.25 3.67157 1.4638 3.38129 1.77754 3.28384C2.09128 3.1864 2.43191 3.30448 2.61803 3.57519L12.25 17.5853V4C12.25 3.58579 12.5858 3.25 13 3.25Z",
    fill: "#76B72A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.25 13C15.25 12.5858 15.5858 12.25 16 12.25H22C22.4142 12.25 22.75 12.5858 22.75 13C22.75 13.4142 22.4142 13.75 22 13.75H16C15.5858 13.75 15.25 13.4142 15.25 13Z",
    fill: "#76B72A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.502 4.75L17.5039 4.75001C17.0898 4.75001 16.7539 5.08578 16.7539 5.50004M16.7539 5.50004L16.7541 8.50001C16.7541 8.5 16.7541 8.50002 16.7541 8.50001C16.7542 8.91426 17.09 9.25 17.5041 9.25H20.5021C20.9163 9.25 21.2521 8.91422 21.2521 8.50001C21.2521 8.5 21.2521 8.50001 21.2521 8.50001L21.252 5.5C21.252 5.08581 20.9162 4.75 20.502 4.75M17.5039 3.25001L20.502 3.25C21.7446 3.25 22.752 4.2573 22.752 5.49994C22.752 5.49994 22.752 5.49995 22.752 5.49994L22.7521 8.49995C22.7521 9.74261 21.7447 10.75 20.5021 10.75H17.5041C16.2615 10.75 15.2543 9.7427 15.2541 8.50019L15.2539 5.50014C15.2539 4.2575 16.2613 3.25001 17.5039 3.25001V4.00001V3.25001Z",
    fill: "#76B72A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNumber);
export default __webpack_public_path__ + "static/media/ic-number.98474b998f9cab3b63a01dff490aea86.svg";
export { ForwardRef as ReactComponent };